import { Component, OnInit } from '@angular/core';
import { Porteur } from "../shared/porteur";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-porteur-details',
  templateUrl: './porteur-details.component.html',
  styleUrls: ['./porteur-details.component.scss']
})
export class PorteurDetailsComponent implements OnInit {

  porteur: Porteur;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.getPorteur();
  }

  getPorteur() {
    this.route.data.subscribe(data => {
      this.porteur = data.porteur;
    })
  }
}
